import { render, staticRenderFns } from "./MusicaViva.vue?vue&type=template&id=2826a035&"
import script from "./MusicaViva.vue?vue&type=script&lang=ts&"
export * from "./MusicaViva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports